import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const PECtaSection = () => (
    <div className="lp-pe-cta">
        <div className="lp-pe-wrap">
            <div className="lp-pe-cta-band" data-lp-reveal>
                <h2>Ready to grow your portfolio value</h2>
                <p>Join Diligentsia free — and start delivering more for every portfolio company, with Morsebridge powering the platform layer.</p>
                <div className="lp-pe-cta-row">
                    <a className="lp-pe-btn lp-pe-btn--white" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call</a>
                    <Link className="lp-pe-btn lp-pe-btn--ghost" to={ROUTES.REGISTER}>Register free</Link>
                </div>
            </div>
        </div>
    </div>
);

export default PECtaSection;
